import api from './api';

const preProductionService = {
  // ========================
  // CONFERÊNCIA DE MEDIDAS
  // ========================

  // Listar conferências de medidas de um projeto
  getMeasurementChecks: async (projectId) => {
    try {
      const response = await api.get(`/pre-production/projects/${projectId}/measurement-checks`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar conferências de medidas:', error);
      throw error;
    }
  },

  // Criar conferência de medidas
  createMeasurementCheck: async (projectId, data) => {
    try {
      const response = await api.post(`/pre-production/projects/${projectId}/measurement-checks`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar conferência:', error);
      throw error;
    }
  },

  // Atualizar conferência de medidas
  updateMeasurementCheck: async (checkId, data) => {
    try {
      const response = await api.put(`/pre-production/measurement-checks/${checkId}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar conferência:', error);
      throw error;
    }
  },

  // Aprovar conferência
  approveMeasurementCheck: async (checkId) => {
    try {
      const response = await api.post(`/pre-production/measurement-checks/${checkId}/approve`);
      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar:', error);
      throw error;
    }
  },

  // Rejeitar conferência
  rejectMeasurementCheck: async (checkId, reason) => {
    try {
      const response = await api.post(`/pre-production/measurement-checks/${checkId}/reject`, { rejection_reason: reason });
      return response.data;
    } catch (error) {
      console.error('Erro ao rejeitar:', error);
      throw error;
    }
  },

  // Listar conferências agendadas
  getScheduledMeasurements: async (days = 7) => {
    try {
      const response = await api.get(`/pre-production/measurement-checks/scheduled`, { params: { days } });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar agendadas:', error);
      throw error;
    }
  },

  // ========================
  // PLANO DE CORTE
  // ========================

  // Listar planos de corte
  getCutPlans: async (projectId) => {
    try {
      const response = await api.get(`/pre-production/projects/${projectId}/cut-plans`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar planos de corte:', error);
      throw error;
    }
  },

  // Criar plano de corte
  createCutPlan: async (projectId, data) => {
    try {
      const response = await api.post(`/pre-production/projects/${projectId}/cut-plans`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar plano:', error);
      throw error;
    }
  },

  // Obter itens do plano
  getCutPlanItems: async (cutPlanId) => {
    try {
      const response = await api.get(`/pre-production/cut-plans/${cutPlanId}/items`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      throw error;
    }
  },

  // Adicionar item ao plano
  addCutPlanItem: async (cutPlanId, data) => {
    try {
      const response = await api.post(`/pre-production/cut-plans/${cutPlanId}/items`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar item:', error);
      throw error;
    }
  },

  // Atualizar item
  updateCutPlanItem: async (itemId, data) => {
    try {
      const response = await api.put(`/pre-production/cut-plan-items/${itemId}`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar item:', error);
      throw error;
    }
  },

  // Deletar item
  deleteCutPlanItem: async (itemId) => {
    try {
      const response = await api.delete(`/pre-production/cut-plan-items/${itemId}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar item:', error);
      throw error;
    }
  },

  // Finalizar plano de corte
  finalizeCutPlan: async (cutPlanId) => {
    try {
      const response = await api.post(`/pre-production/cut-plans/${cutPlanId}/finalize`);
      return response.data;
    } catch (error) {
      console.error('Erro ao finalizar:', error);
      throw error;
    }
  },

  // Aprovar plano de corte
  approveCutPlan: async (cutPlanId) => {
    try {
      const response = await api.post(`/pre-production/cut-plans/${cutPlanId}/approve`);
      return response.data;
    } catch (error) {
      console.error('Erro ao aprovar plano:', error);
      throw error;
    }
  },

  // Obter resumo do plano
  getCutPlanSummary: async (cutPlanId) => {
    try {
      const response = await api.get(`/pre-production/cut-plans/${cutPlanId}/summary`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar resumo:', error);
      throw error;
    }
  },

  // ========================
  // PEDIDO DE MATERIAIS
  // ========================

  // Listar pedidos de materiais
  getMaterialOrders: async (projectId, orderType = null) => {
    try {
      const response = await api.get(`/pre-production/projects/${projectId}/material-orders`, {
        params: { order_type: orderType }
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar pedidos:', error);
      throw error;
    }
  },

  // Criar pedido de materiais
  createMaterialOrder: async (projectId, data) => {
    try {
      const response = await api.post(`/pre-production/projects/${projectId}/material-orders`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar pedido:', error);
      throw error;
    }
  },

  // Obter itens do pedido
  getMaterialOrderItems: async (orderId) => {
    try {
      const response = await api.get(`/pre-production/material-orders/${orderId}/items`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      throw error;
    }
  },

  // Atualizar status do pedido
  updateMaterialOrderStatus: async (orderId, status) => {
    try {
      const response = await api.put(`/pre-production/material-orders/${orderId}/status`, { status });
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar status:', error);
      throw error;
    }
  },

  // ========================
  // ENTRADA DE MATERIAIS
  // ========================

  // Listar entradas
  getReceipts: async (projectId) => {
    try {
      const response = await api.get(`/pre-production/projects/${projectId}/receipts`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar entradas:', error);
      throw error;
    }
  },

  // Criar entrada
  createReceipt: async (projectId, data) => {
    try {
      const response = await api.post(`/pre-production/projects/${projectId}/receipts`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar entrada:', error);
      throw error;
    }
  },

  // Obter itens da entrada
  getReceiptItems: async (receiptId) => {
    try {
      const response = await api.get(`/pre-production/receipts/${receiptId}/items`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      throw error;
    }
  },

  // Verificar entrada
  verifyReceipt: async (receiptId) => {
    try {
      const response = await api.post(`/pre-production/receipts/${receiptId}/verify`);
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar:', error);
      throw error;
    }
  },

  // ========================
  // PREPARAÇÃO DE MATERIAIS
  // ========================

  // Listar preparações
  getMaterialPrep: async (projectId) => {
    try {
      const response = await api.get(`/pre-production/projects/${projectId}/material-prep`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar preparações:', error);
      throw error;
    }
  },

  // Criar preparação
  createMaterialPrep: async (projectId, data) => {
    try {
      const response = await api.post(`/pre-production/projects/${projectId}/material-prep`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar preparação:', error);
      throw error;
    }
  },

  // Obter itens da preparação
  getMaterialPrepItems: async (prepId) => {
    try {
      const response = await api.get(`/pre-production/material-prep/${prepId}/items`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar itens:', error);
      throw error;
    }
  },

  // Adicionar item à preparação
  addItemToPrep: async (prepId, data) => {
    try {
      const response = await api.post(`/pre-production/material-prep/${prepId}/items`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao adicionar item:', error);
      throw error;
    }
  },

  // Marcar como pronto
  markMaterialPrepReady: async (prepId) => {
    try {
      const response = await api.post(`/pre-production/material-prep/${prepId}/ready`);
      return response.data;
    } catch (error) {
      console.error('Erro ao marcar pronto:', error);
      throw error;
    }
  },

  // Emitir para produção
  issueMaterials: async (prepId) => {
    try {
      const response = await api.post(`/pre-production/material-prep/${prepId}/issue`);
      return response.data;
    } catch (error) {
      console.error('Erro ao emitir:', error);
      throw error;
    }
  },

  // ========================
  // CONFIGURAÇÕES
  // ========================

  // Obter configurações
  getConfig: async () => {
    try {
      const response = await api.get('/pre-production/preproduction/config');
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar configurações:', error);
      throw error;
    }
  },

  // Atualizar configuração
  updateConfig: async (data) => {
    try {
      const response = await api.put('/pre-production/preproduction/config', data);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar configuração:', error);
      throw error;
    }
  }
};

export default preProductionService;